import React from 'react'
import PropTypes from 'prop-types'
import {useFragmentInjector} from '@madflys/react'
import RemoteComponent from './RemoteComponent'

const ExternalComponent = ({viaWebC, id, url}) => {
  const element = viaWebC ? useFragmentInjector(id) : null

  return viaWebC
    ? element
    : <RemoteComponent id={id} url={url} />
}

ExternalComponent.propTypes = {
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  viaWebC: PropTypes.bool.isRequired
}

export default ExternalComponent
